import { FC, SVGProps } from 'react';
import { Icons } from 'assets';
import { FieldVerdict } from '../_core/field';

export const messageIcon: Record<
  FieldVerdict | 'hint',
  FC<SVGProps<SVGSVGElement>>
> = {
  error: Icons.CrossCircleFilled,
  warning: Icons.ExclamationTriangleFilled,
  success: Icons.CheckCircleFilled,
  hint: Icons.ExclamationCircleFilled,
};
